import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getArticuloId } from "../../redux/articulos/articulosAction";


export default function ArticuloDetail(){
    const dispatch = useDispatch();
    const {id} = useParams();
    const articuloId = useSelector(state => state.articulos.articuloId);

    useEffect(() => {
        dispatch(getArticuloId(id));
    }, [dispatch]);

    console.log(articuloId);
    

    return(
        <>
            <div className="bg-custom container-custom">
                <div className="container m-8 text-orange-500 text-[10pt] font-bold">
                <div>
                    <p className="my-2">Codigo Articulo: {articuloId.codArticulo}</p>
                    <p>Nombre: {articuloId.nombre}</p>
                    <p className="my-2">Ciclo: {articuloId.ciclo}</p>
                    <p>Precio: {articuloId.precio}</p>
                    <p className="my-2">ISBN: {articuloId.isbn}</p>
        </div>
                </div>
            </div>
        </>
    )
}